import React, { useState, useEffect } from "react";
import {
    Box,
    Button,
    Dialog,
    DialogContent,
    Grid,
    IconButton,
    TextField,
    Typography,
} from "@mui/material";
import { HugeiconsIcon } from "@hugeicons/react";
import { Cancel01Icon, Upload01Icon } from "@hugeicons/core-free-icons";

const FieldWithLabel = ({ label, value, onChange, multiline = false, type = "text" }) => (
    <Box sx={{ mb: 2 }}>
        <Typography variant="body2" sx={{ fontWeight: "bold", mb: 0.5 }}>
            {label}
        </Typography>
        <TextField
            fullWidth
            size="small"
            type={type}
            value={value}
            onChange={(e) => onChange(e.target.value)}
            placeholder={`Enter ${label.toLowerCase()}`}
            multiline={multiline}
            rows={multiline ? 2 : 1}
            InputLabelProps={type === "date" ? { shrink: true } : {}}
            sx={{
                "& .MuiOutlinedInput-root": {
                    borderRadius: "15px",
                    backgroundColor: "white",
                },
            }}
        />
    </Box>
);

const EditBillDetails = ({ open, onClose, onSave, bill }) => {
    const [billData, setBillData] = useState({
        id: "",
        bill_name: "",
        amount: "",
        due_date: "",
        description: "",
        status: "",
        image: null,
        imagePreview: null,
    });

    useEffect(() => {
        if (bill) {
            setBillData({
                id: bill.id || "",
                bill_name: bill.bill_name || "",
                amount: bill.amount || "",
                due_date: bill.due_date || "",
                createdAt: bill.date || "",
                description: bill.description || "",
                status: bill.status || "",
                image: null,
                imagePreview: bill.img || null,
            });
        }
    }, [bill]);


    const handleChange = (field, value) => {
        setBillData((prev) => ({ ...prev, [field]: value }));
    };

    const handleImageUpload = (e) => {
        const file = e.target.files[0];
        if (file) {
            handleChange("image", file);
            handleChange("imagePreview", URL.createObjectURL(file));
        }
    };

    const handleSave = () => {
        if (onSave) {
            onSave(billData);
        }
        onClose();
    };

    return (
        <Dialog
            open={open}
            onClose={onClose}
            maxWidth="md"
            PaperProps={{ sx: { borderRadius: "20px" } }}
        >
            <DialogContent sx={{ p: 0, backgroundColor: "#ffffff" }}>
                {/* Header */}
                <Box
                    sx={{
                        background: "#EEF4FF",
                        px: 3,
                        py: 1.5,
                        display: "flex",
                        justifyContent: "space-between",
                        alignItems: "center",
                        borderTopLeftRadius: "12px",
                        borderTopRightRadius: "12px",
                    }}
                >
                    <Typography fontWeight="600" fontSize="16px">
                        Edit Bill Details
                    </Typography>
                    <IconButton size="small" onClick={onClose}>
                        <HugeiconsIcon icon={Cancel01Icon} size={20} color="#344054" />
                    </IconButton>
                </Box>

                {/* Content */}
                <Box sx={{ px: 3, py: 3 }}>
                    {/* Top Fields */}
                    <Grid container spacing={2}>
                        <Grid item xs={12} sm={4}>
                            <FieldWithLabel
                                label="Bill Id"
                                value={billData.id}
                                onChange={(val) => handleChange("id", val)}
                            />
                        </Grid>
                        <Grid item xs={12} sm={4}>
                            <FieldWithLabel
                                label="Bill Name"
                                value={billData.bill_name}
                                onChange={(val) => handleChange("bill_name", val)}
                            />
                        </Grid>
                        <Grid item xs={12} sm={4}>
                            <FieldWithLabel
                                label="Amount"
                                value={billData.amount}
                                onChange={(val) => handleChange("amount", val)}
                            />
                        </Grid>
                    </Grid>
                    <Grid container spacing={2}>
                        <Grid item xs={12} sm={4}>
                            <FieldWithLabel
                                label="Status"
                                value={billData.status}
                                onChange={(val) => handleChange("status", val)}
                            />
                        </Grid>
                        <Grid item xs={12} sm={4}>
                            <FieldWithLabel
                                label="Bill created date"
                                value={billData.createdAt}
                                onChange={(val) => handleChange("createdAt", val)}
                                type="date"
                            />
                        </Grid>
                        <Grid item xs={12} sm={4}>
                            <FieldWithLabel
                                label="Bill due date"
                                value={billData.due_date}
                                onChange={(val) => handleChange("due_date", val)}
                                type="date"
                            />
                        </Grid>
                    </Grid>

                    {/* Reminder */}
                    {/* <Box
            sx={{
              mt: 4,
              p: 2,
              borderRadius: "8px",
              border: "1px solid #E0E0E0",
            }}
          >
            <Typography fontWeight={600} fontSize={14} mb={2}>
              Set reminder
            </Typography>
            <Grid container spacing={2}>
              <Grid item xs={12} sm={6}>
                <FieldWithLabel
                  label="Date selected"
                  value={billData.reminderDate}
                  onChange={(val) => handleChange("reminderDate", val)}
                  type="date"
                />
              </Grid>
              <Grid item xs={12} sm={6}>
                <FieldWithLabel
                  label="Notify"
                  value={billData.notify}
                  onChange={(val) => handleChange("notify", val)}
                />
              </Grid>
              <Grid item xs={12}>
                <FieldWithLabel
                  label="Comments"
                  value={billData.comments}
                  onChange={(val) => handleChange("comments", val)}
                  multiline
                />
              </Grid>
            </Grid>
          </Box> */}

                    {/* About this Bill */}
                    <Box sx={{ mt: 3 }}>
                        <FieldWithLabel
                            label="About this Bill"
                            value={billData.description}
                            onChange={(val) => handleChange("description", val)}
                            multiline
                        />
                    </Box>

                    {/* Service Center Details */}
                    {/* <Box sx={{ mt: 3 }}>
            <Typography fontWeight={600} fontSize={14} mb={2}>
              Service Center Details
            </Typography>
            <Grid container spacing={2}>
              <Grid item xs={12} sm={6}>
                <FieldWithLabel
                  label="Service Manager Name"
                  value={billData.serviceManager}
                  onChange={(val) => handleChange("serviceManager", val)}
                />
              </Grid>
              <Grid item xs={12} sm={6}>
                <FieldWithLabel
                  label="Mobile number"
                  value={billData.mobile}
                  onChange={(val) => handleChange("mobile", val.replace(/\D/, ""))}
                  type="tel"
                />
              </Grid>
            </Grid>
          </Box> */}

                    {/* Bill Image Upload */}
                    <Box sx={{ mt: 3, textAlign: "center" }}>
                        {billData.imagePreview ? (
                            <Box sx={{ position: "relative", display: "inline-block" }}>
                                <img
                                    src={billData.imagePreview}
                                    alt="Bill Preview"
                                    style={{
                                        width: "500px",
                                        borderRadius: "10px",
                                        border: "1px solid #E0E0E0",
                                    }}
                                />
                                <IconButton
                                    size="small"
                                    onClick={() => handleChange("imagePreview", null)}
                                    sx={{
                                        position: "absolute",
                                        top: -10,
                                        right: -10,
                                        backgroundColor: "#fff",
                                        border: "1px solid #ccc",
                                        p: 0.5,
                                    }}
                                >
                                    <HugeiconsIcon icon={Cancel01Icon} size={18} color="#FF0000" />
                                </IconButton>
                            </Box>
                        ) : (
                            <Typography sx={{ color: "#999", mb: 2, fontSize: "13px" }}>
                                No Preview Image
                            </Typography>
                        )}

                        {!billData.imagePreview && (
                            <Button
                                component="label"
                                variant="outlined"
                                fullWidth
                                startIcon={<HugeiconsIcon icon={Upload01Icon} size={18} />}
                                sx={{
                                    mt: 2,
                                    textTransform: "none",
                                    borderRadius: "50px",
                                    fontWeight: "bold",
                                    borderStyle: "dashed",
                                    borderColor: "#D9DDE3",
                                    backgroundColor: "#F3F5F9",
                                    color: "#7A7F88",
                                    display: "flex",
                                    justifyContent: "center",
                                    alignItems: "center",
                                    gap: 1,
                                    fontSize: 13,
                                }}
                            >
                                Upload Bill
                                <input type="file" hidden accept="image/*" onChange={handleImageUpload} />
                            </Button>
                        )}
                    </Box>


                    {/* Save Button */}
                    <Box sx={{ display: "flex", justifyContent: "end", mt: 3 }}>
                        <Button
                            variant="contained"
                            onClick={handleSave}
                            sx={{
                                background: "#0949b0",
                                color: "#fff",
                                borderRadius: "100px",
                                textTransform: "none",
                                fontSize: "12px",
                            }}
                        >
                            Save Changes
                        </Button>
                    </Box>
                </Box>
            </DialogContent>
        </Dialog>
    );
};

export default EditBillDetails;
